import {PuzzlesResponse} from './types';
import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function usePuzzlesApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const mutation = useMutation<PuzzlesResponse, Error, void>(
    async filters => {
      // Logging commented out: this response carries the puzzle SOLUTION
      // fields (best_response / best_possible_response / best_move / ...), so
      // printing it put the answers in the console for anyone with devtools
      // open. Same reasoning as the obfuscation work — see
      // Utils/puzzleEncrypter.ts.
      // console.log('Fetching puzzle data .. ', JSON.stringify(filters));
      if (!filters) filters = {};
      let q = {};

      for (var key in filters) {
        const element = filters[key];
        // console.log(element);
        q[key] = element.value || element;
      }
      // console.log(q);
      const objString = '?' + new URLSearchParams(q).toString();
      // console.log('Query params = ', objString);

      const response = await ChessRestClient.get(
        `learning/puzzles/${objString}`,
      );
      // console.log(response.data);
      return response.data;
    },
    {
      onSuccess: data => {
        // console.log('Puzzles Data = ', data);
        if (handleOnSuccess && data.success) handleOnSuccess(data);
        else if (handleOnError) handleOnError(data);
      },
    },
  );

  return {
    ...mutation,
  };
}
